/**
 * Embed Open Sans (UI font) into a jsPDF instance.
 */

import openSansRegularUrl from '../../assets/fonts/OpenSans-Regular.ttf';
import openSansBoldUrl from '../../assets/fonts/OpenSans-Bold.ttf';

export const PDF_FONT_FAMILY = 'OpenSans';

let cachedRegularB64 = null;
let cachedBoldB64 = null;

const arrayBufferToBase64 = (buffer) => {
  const bytes = new Uint8Array(buffer);
  const chunkSize = 0x8000;
  let binary = '';
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
  }
  return btoa(binary);
};

const fetchFontBase64 = async (url) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load PDF font: ${response.status}`);
  }
  return arrayBufferToBase64(await response.arrayBuffer());
};

/**
 * Register Open Sans normal + bold on a jsPDF document.
 * Safe to call multiple times; falls back to Helvetica if load fails.
 * @param {import('jspdf').jsPDF} pdf
 * @returns {Promise<{ family: string, ok: boolean }>}
 */
export async function registerOpenSansForPdf(pdf) {
  try {
    if (!cachedRegularB64) {
      cachedRegularB64 = await fetchFontBase64(openSansRegularUrl);
    }
    if (!cachedBoldB64) {
      cachedBoldB64 = await fetchFontBase64(openSansBoldUrl);
    }

    pdf.addFileToVFS('OpenSans-Regular.ttf', cachedRegularB64);
    pdf.addFont('OpenSans-Regular.ttf', PDF_FONT_FAMILY, 'normal');
    pdf.addFileToVFS('OpenSans-Bold.ttf', cachedBoldB64);
    pdf.addFont('OpenSans-Bold.ttf', PDF_FONT_FAMILY, 'bold');
    pdf.setFont(PDF_FONT_FAMILY, 'normal');
    return { family: PDF_FONT_FAMILY, ok: true };
  } catch (err) {
    console.warn('[PDF] Open Sans unavailable; using Helvetica', err);
    pdf.setFont('helvetica', 'normal');
    return { family: 'helvetica', ok: false };
  }
}
